<template>
    <div  class="is_headapp">
        <h1>{{title}}</h1>

        <v-row v-if="ready">
            <v-col>
                <template v-for="f in fields">
                        <template v-if="!f.hide">
                            <h3 v-if="f.type=='header'">{{f.description}}</h3>
                            <filter-date :field="f" :filter_change="filter_change" v-if="f.type=='date'"/>
                            <filter-select :field="f" :filter_change="filter_change" v-if="f.type=='select'"/>
                            <filter-checkbox :field="f" :filter_change="filter_change" v-if="f.type=='checkbox'"/>
                            <hr v-if="f.type=='hr'" style="height:2px;border-width:0;color:gray;background-color:gray; margin-top: 10px;">
                        </template>
                </template>
                <v-btn v-if="all_required" @click.prevent="transfere">Перевести</v-btn>
                <div v-else>
                    Заполните все обязательные поля
                </div>
            </v-col>
            <v-col>
                <p class="ok">{{result_message}}</p>
                <errors :errors="errors" />

            </v-col>
        </v-row>


    </div>
</template>
<script>
export default {
    name:'transfere-cards',
    props:['params','is_headapp'],
    data(){
        return {
            title:'Превод карт ОП',
            result_message:'',
            fields:[],
            ready:false,
            errors:[],
            filters_hash:null,
            fields_hash:{} // для быстрого доступа к полям в frontend зависимостях

        }
    },
    created(){
        let t=this
        t.$http.get(`${BackendBase}/transfere-cards/${t.params.config}`).then(
            r=>{
                let d=r.data
                if(d.success){
                    for(let f of d.fields) // нужно чтобы работал hide
                        f.hide=f.hide?true:false

                    t.fields=d.fields
                    t.create_filters_hash()
                }
            }
        )


    },
    methods:{
        create_filters_hash(){
            let t=this, fh={}
            for(let f of t.fields){
                if(f.type!=='header')
                    fh[f.name]=''
                t.fields_hash[f.name]=f
            }

            t.filters_hash=fh
            t.ready=true
        },
        filter_change(filter){


            let t=this
            t.filters_hash[filter.name]=filter.value

            let frontend=filter.frontend
            if (frontend) {
                let fd = frontend.fields_dependence;
                if (fd) {
                    try {
                        // Создаем функцию из строки
                        const dynamicFunction = new Function('value', `return (${fd})(value)`);
                        const data = dynamicFunction(filter.value);
                        for (let i = 0; i < data.length; i += 2) {
                            const name = data[i];
                            const attribites = data[i + 1];

                            console.log('name:', name);
                            for(let a in attribites){
                                console.log(`a: ${a} value: ${attribites[a]}`);
                                t.fields_hash[name][a]=attribites[a]
                            }

                            console.log('---');
                        }

                        // Используйте result по необходимости
                    } catch (error) {
                        console.error('Error executing dynamic function:', error);
                    }
                }
            }
        },
        transfere(){
            let t=this, fh={}
            // собираем новый filters_hash, исключая фильтры с hide
            for(let f of t.fields){
                if(!f.hide)
                    fh[f.name]=t.filters_hash[f.name]
            }

            t.$http.post(
                `${BackendBase}/transfere-cards/${t.params.config}`,
                {
                    'action':'transfere',
                    'values': fh,
                    'config': t.params.config
                }
            ).then(
                r=>{
                    let d=r.data
                    if(d.success){
                        t.result_message=d.result_message

                    }
                    else{
                        t.result_message=''
                    }
                    t.errors=d.errors
                }
            )

        }
    },
    computed:{
        all_required(){

            for(let f of this.fields){
                if(f.required){
                    let v=this.filters_hash[f.name]
                    if(!v){
                        return false
                    }
                    if(f.range){
                        if(!v.length){
                            return false
                        }
                        if(f.type=='date'){
                            if(v.length!=2)
                                return false
                            if(!v[0] || !v[1])
                                return false
                        }
                    }


                }
            }
            return true
        }
    }
}
</script>
<style lang="scss">
    @import '@/styles/variables.scss';
    .is_headapp {margin: 20px;}
    .is_headapp h1 {margin: 20px 0px; }
    .ok {color: green; font-weight: bold; background: none !important;}
</style>